import React, { useState, useEffect } from "react";

import HeaderTemplate from "../templates/HeaderTemplate";
import { useNavigate } from "react-router-dom";
import { MissionPostRequestBody } from "../common/type/type";
import { Box } from "@mui/material";

import env from "../common/config/env";

import ActionDialogButton from "../atoms/ActionDialogButton";
import { createMission, deliveryMission } from "../../services/missionApi";
import { MissionFormBase } from "../molecules/MissionFormBase";

export default function MissionNew() {
  const [formData, setFormData] = useState<MissionPostRequestBody>({
    missionTypeId: "019372c6-c935-7261-8955-f55c1b7d9ff2", // アプリ起動のミッションタイプId
    title: "",
    conditions: JSON.stringify({
      targetYearMonth: null,
      threshold: null,
    }),
    point: null,
    startedAt: null,
    endedAt: null,
    missionDisplay: {
      missionDisplayTypeId: "019372c6-c935-77cd-aea1-e2749cb54862", // 仮のUUID
      detail: JSON.stringify({
        title: "",
        description: [""],
      }),
    },
  });

  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);

  const [isFormValid, setIsFormValid] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleClickOpen = () => {
    console.log(formData);
    setOpen(true);
  };

  // missionTypeIdごとにconditionsを整形する関数
  function adjustConditionsByMissionType(formData: MissionPostRequestBody) {
    const { missionTypeId, conditions } = formData;
    if (
      missionTypeId === "019372c6-c935-72c6-ab12-e352aba76fac" ||
      missionTypeId === "019372c6-c935-732d-b4cc-889b56cd7857"
    ) {
      // 電気代シミュレーションまたは記事閲覧はconditions自体をnull
      return null;
    } else if (missionTypeId === "019372c6-c935-7261-8955-f55c1b7d9ff2") {
      // アプリ起動: targetYearMonthのみ
      const current = JSON.parse(conditions);
      return JSON.stringify({ targetYearMonth: current.targetYearMonth });
    }
    return conditions;
  }

  // missionDisplayTypeIdごとにmissionDisplay.detailを整形する関数
  function adjustMissionDisplayDetail(formData: MissionPostRequestBody) {
    const { missionDisplay } = formData;
    const detailObj = JSON.parse(missionDisplay.detail);
    if (
      missionDisplay.missionDisplayTypeId ===
      "019372c6-c935-7000-9eef-4043e704ad85"
    ) {
      // WebView: urlのみ
      return JSON.stringify({ url: detailObj.url || "" });
    }
    return missionDisplay.detail;
  }

  const handleCreate = async () => {
    let submitData = {
      ...formData,
      conditions: adjustConditionsByMissionType(formData),
      missionDisplay: {
        ...formData.missionDisplay,
        detail: adjustMissionDisplayDetail(formData),
      },
    };
    if (env.useMock) {
      console.log("---mock---");
      console.log(submitData);
      navigate("/missions");
      return;
    }
    setIsSubmitting(true);
    try {
      console.log(submitData);
      const result = await createMission(submitData);
      if (result && result.id) {
        // ミッション作成成功後、配信APIを呼ぶ
        const deliveryResult = await deliveryMission(result.id);
        if (deliveryResult) {
          console.log("delivery success", deliveryResult);
          navigate("/missions");
        } else {
          setError("ミッションの配信に失敗しました。設計にご連絡ください。");
        }
      } else {
        alert(
          "ミッションの作成に失敗しました。ログインし直すか、設計にご連絡ください。"
        );
      }
    } catch (error) {
      alert(
        "ミッションの作成に失敗しました。ログインし直すか、設計にご連絡ください。"
      );
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  if (error) return <p>{error}</p>;

  return (
    <div>
      <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
        <div>
          <HeaderTemplate />
        </div>

        <Box
          sx={{
            paddingTop: "20px",
          }}
        >
          <MissionFormBase
            formData={formData}
            setFormData={setFormData}
            onValidationChange={setIsFormValid}
            radioDisabled={false}
          />
        </Box>
        <ActionDialogButton
          type="create"
          open={open}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          handleAction={handleCreate}
          actionDisabled={!isFormValid}
          isSubmitting={isSubmitting}
        />
      </Box>
    </div>
  );
}
